const MAP_PERSISTENT = [
    //{root: 'profiliOrari', properties: ['profiliOrariTotaliIndividui']},
    //{root: 'datiRegistro', properties: ['resocontoMese', 'error']}
];

export function loadStorage() {
    try {
        const serializedState = sessionStorage.getItem('store');
        if (serializedState === null) {
            return {};

        } else {
            const store = JSON.parse(serializedState);

            MAP_PERSISTENT.map(objPersist => store[objPersist.root] ?
                store[objPersist.root] = Object.assign(
                    {},
                    store[objPersist.root],
                    objPersist.properties.map(property => ({[property]: convertArrayToMap(store[objPersist.root][property])})).reduce((obj, currentObj) => Object.assign(obj, currentObj), {})
                ) : null
            );

            return store;
        }

    } catch (e) {
        return {};
    }
}

export function saveStorage(store) {
    try {

        MAP_PERSISTENT.forEach(objPersist => store[objPersist.root] ?
            store[objPersist.root] =
                Object.assign({},
                    store[objPersist.root],
                    objPersist.properties.map(property => ({[property]: convertMapToArray(store[objPersist.root][property])})).reduce((obj, currentObj) => Object.assign(obj, currentObj), {})
                ) : null
        );

        const serializedState = JSON.stringify(store);
        sessionStorage.setItem('store', serializedState);
    } catch (e) {
        return null;
    }
}

function convertMapToArray(profiliOrariTotaliIndividui) {
    const array = [];
    if (profiliOrariTotaliIndividui.size > 0)
        profiliOrariTotaliIndividui.forEach((value, key) => array.push({key: key, value: value}));

    return array;
}


function convertArrayToMap(profiliOrariTotaliIndividui) {
    let mapObj = new Map();
    if (profiliOrariTotaliIndividui.length > 0)
        profiliOrariTotaliIndividui.map(obj => mapObj.set(obj.key, obj.value));

    return mapObj;
}

